import { Button, ToastBody, ToastFooter, ToastTitle } from '@apollo/orbit';
import React from 'react';

export const NewFedVersionToast = ({ onClick }: { onClick: () => void }) => {
  return (
    <>
      <ToastTitle>Federation update available</ToastTitle>
      <ToastBody>
        A new version of Federation is now available. Continue below to learn
        more and upgrade.
      </ToastBody>
      <ToastFooter>
        <Button onClick={onClick} variant="primary">
          Learn more
        </Button>
      </ToastFooter>
    </>
  );
};
